import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Achievement } from '../../../core/competitions/competitions';

/** Presentational — no data fetching of its own. Used from both the
 *  owner management view and the contestant landing page (F-004). */
@Component({
  selector: 'app-achievements-list',
  imports: [],
  templateUrl: './achievements-list.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './achievements-list.css',
})
export class AchievementsList {
  readonly achievements = input<Achievement[]>([]);

  displayName(a: Achievement): string {
    return a.achievementDefinition?.name ?? a.name ?? 'Custom Achievement';
  }

  displayDescription(a: Achievement): string | null {
    return a.achievementDefinition?.description ?? a.description;
  }
}
